<template>
  <el-dialog :visible.sync="visible" :title="!dataForm.id ? $t('add') : $t('update')" :close-on-click-modal="false" :close-on-press-escape="false">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmitHandle()" :label-width="$i18n.locale === 'en-US' ? '120px' : '80px'">
          <el-form-item label="域名" prop="domain">
          <el-input v-model="dataForm.domain" placeholder="域名"></el-input>
      </el-form-item>
          
          <el-form-item label="URL" prop="url">
          <el-input v-model="dataForm.url" placeholder="URL"></el-input>
      </el-form-item>
          <el-form-item label="xpath1" prop="xpath1">
          <el-input v-model="dataForm.xpath1" placeholder="xpath1"></el-input>
      </el-form-item>
          <el-form-item label="xpath2" prop="xpath2">
          <el-input v-model="dataForm.xpath2" placeholder="xpath2"></el-input>
      </el-form-item>
      <div style="display: flex;">
        <el-form-item label="产品名称" prop="productId">
          <el-select v-model="dataForm.productId" filterable clearable placeholder="产品名称">
            <el-option
                    v-for="(item,index) in productList"
                    :key="index"
                    :label="item.label"
                    :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="状态" prop="status">
          <el-select v-model="dataForm.status" filterable clearable placeholder="状态：1启用 0禁用">
            <el-option
                    v-for="item in statusList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
      </div>       
      </el-form>
    <template slot="footer">
      <el-button @click="qx()">{{ $t('cancel') }}</el-button>
      <el-button type="primary" @click="dataFormSubmitHandle()">{{ $t('confirm') }}</el-button>
    </template>
  </el-dialog>
</template>

<script>
import debounce from 'lodash/debounce'
export default {
  data () {
    return {
      visible: false,
      dataForm: {
        id: '',
        domain: '',
        productId: '',
        url: '',
        xpath1: '',
        xpath2: '',
        status: '',
        creator: '',
        createDate: '',
        updateBy: '',
        updateTime: ''
      },
      statusList: [
        { value: 1, label: '启用' },
        { value: 0, label: '禁用' }
      ],
      productList:[],
    }
  },
  computed: {
    dataRule () {
      return {
        domain: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        productId: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        url: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        xpath1: [
          { required: false, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        xpath2: [
          { required: false, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        status: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    init () {
      this.visible = true
      this.getProductList()
      this.$nextTick(() => {
        this.$refs['dataForm'].resetFields()
        if (this.dataForm.id) {
          this.getInfo()
        }
      })
    },
     // 产品名称列表
    async getProductList() {
      this.$http.get(`sys/slproduct/page?order=&orderField=&page=1&limit=500`).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        if (res.data!=null){
          res.data.list.forEach(element => {
            this.productList.push({label:element.productName,value:element.id})
          })
        }
      }).catch(() => {})
    },
    // 获取信息
    getInfo () {
      this.$http.get(`/sys/productpage/${this.dataForm.id}`).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.dataForm = {
          ...this.dataForm,
          ...res.data
        }
      }).catch(() => {})
    },
    qx(){
      this.visible = false
      this.dataForm = {
        id: '',
        domain: '',
        productId: '',
        url: '',
        xpath1: '',
        xpath2: '',
        status: '',
        creator: '',
        createDate: '',
        updateBy: '',
        updateTime: ''
      }
      this.productList  = []
    },
    // 表单提交
    dataFormSubmitHandle: debounce(function () {
      this.$refs['dataForm'].validate((valid) => {
        if (!valid) {
          return false
        }
        this.$http[!this.dataForm.id ? 'post' : 'put']('/sys/productpage/', this.dataForm).then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          this.$message({
            message: this.$t('prompt.success'),
            type: 'success',
            duration: 500,
            onClose: () => {
              this.visible = false
              this.$emit('refreshDataList')
              this.productList  = []
            }
          })
        }).catch(() => {})
      })
    }, 1000, { 'leading': true, 'trailing': false })
  }
}
</script>
